<template>
  <div class="flash" :class="`flash--${layout}`">
    <div class="flash__inner">
      <FlashMessage
        v-for="message in messages"
        :key="message.id"
        :id="message.id"
        :text="message.text"
        :type="message.type"
        :deleteMessage="deleteMessage"
      />
    </div>
  </div>
</template>

<script>
import stickyfill from 'stickyfilljs'
import { mapGetters } from 'vuex'
import { LAYOUTS } from '@/App.vue'
import FlashMessage from './FlashMessage.vue'

export default {
  name: 'FlashMessages',
  components: {
    FlashMessage,
  },

  props: {
    /**
     * FlashMessages component will only display message of the given context.
     */
    context: {
      type: String,
      default() {
        return this.$CONTEXTS.root
      },
    },
  },

  computed: {
    ...mapGetters({
      messagesByContext: 'flash/messagesByContext',
    }),

    messages() {
      return this.messagesByContext(this.context)
    },

    layout() {
      return this.$route?.meta.layout || LAYOUTS.default
    },
  },

  mounted() {
    if (this.$el.closest('.site-content--checkout')) {
      stickyfill.add(this.$el)
    }
  },

  methods: {
    deleteMessage(id) {
      this.$store.dispatch('flash/removeMessage', id)
    },
  },
}
</script>

<style scoped lang="scss">
.flash {
  position: fixed;
  width: 100%;
  z-index: $navigation-z-index - 2;

  &--simple {
    top: 0;
  }

  .site-content--checkout & {
    position: sticky;
    top: -1px;
    border-top: 1px solid $color-navigation-border;

    // Clearfix for sticky position polyfill (stickyfilljs)
    &:before,
    &:after {
      content: '';
      display: table;
    }
  }

  &__inner {
    display: flex;
    flex-direction: column-reverse; // to fix z indexes on multiple messages
  }
}
</style>
